<template>
  <v-form>
    <v-text-field
      label="New Password"
      v-model.trim="form.new"
      type="text"
      placeholder="New Password"
      id="newPassword"
    ></v-text-field>
    <v-btn @click="updatePassword">Reset password</v-btn>
    <pre>{{ errorMsg }}</pre>
    <pre>{{ user }}</pre>
  </v-form>
</template>

<script>
// @ is an alias to /src

const fb = require("../../firebaseConfig.js");

export default {
  name: "UserReset",
  components: {},
  data() {
    return {
      doc: {},
      user: {},
      errorMsg: "",
      form: {
        new: "",
      },
    };
  },
  created() {
    this.user = fb.auth.currentUser;
  },
  methods: {
    updatePassword(evt) {
      evt.preventDefault();
      const self = this;
      const user = fb.auth.currentUser;
      const newPassword = this.form.new;
      user
        .updatePassword(newPassword)
        .then((user) => {
          // Update successful.

          console.log("Update SuccessFul", user);
          self.logout();
        })
        .catch((error) => {
          // An error occurred
          // ...
          this.errorMsg = error;
        });
    },
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch(() => {});
    },
  },
};
</script>
